export const EXPIRED_AUTH_LINK_MESSAGE =
  'The link has expired. Please request a new one.';

export function getAuthLinkErrorMessage(error) {
  const rawMessage =
    typeof error === 'string'
      ? error
      : error?.response?.data?.message || error?.message || '';

  if (!rawMessage) {
    return EXPIRED_AUTH_LINK_MESSAGE;
  }

  const normalizedMessage = rawMessage.toLowerCase();

  if (
    normalizedMessage.includes('invalid token') ||
    normalizedMessage.includes('token expired') ||
    normalizedMessage.includes('link expired') ||
    normalizedMessage.includes('expired token') ||
    normalizedMessage.includes('jwt expired') ||
    normalizedMessage.includes('invalid or expired')
  ) {
    return EXPIRED_AUTH_LINK_MESSAGE;
  }

  return rawMessage;
}
